<div class="md-modal">
  <div class="md-body">
    <h3>{{ question }}</h3>
    <p class="text-center">
      {{'SHARED.confirmDeleteRecurrence.title' | translate}}
    </p>
    @if (showNotifyClientOption) {
      <div class="text-center custom-control custom-checkbox">
        <input [(ngModel)]="notifyClient" type="checkbox" class="custom-control-input" id="notifyClient" />
        <label class="custom-control-label" for="notifyClient">
          {{ 'SHARED.createBookingModal.notifyClient' | translate }}
        </label>
      </div>
    }
  </div>
  <div class="md-actions">

    <button class="btn btn-md btn-outline mr-2 mb-3" [disabled]="submitted" (click)="close(false, false)">{{'GENERAL.no' | translate}}</button>
    <button class="btn btn-md btn-primary mr-2 mb-3" [disabled]="submitted" (click)="close(true, false)">{{'SHARED.confirmDeleteRecurrence.deleteOnlyThis' | translate}}</button>
    <button class="btn btn-md btn-primary mr mb-3" [disabled]="submitted" (click)="close(false, true)">{{'SHARED.confirmDeleteRecurrence.deleteAll' | translate}}</button>
  </div>
</div>
